export const actions = {
  async dispatchActionsOnFanBaseTab({ dispatch, rootState }) {
    const isChannelEqualTodas = rootState.ui.channel.toUpperCase() === 'TODAS';

    await Promise.allSettled([
      dispatch({ type: 'charts/fetchFanbaseEvolutionTable' }, { root: true }),
      !isChannelEqualTodas && dispatch({ type: 'charts/fetchFanbaseEvolution' }, { root: true }),
      !isChannelEqualTodas && dispatch({ type: 'insights/fetchFanbaseEvolutionInsights' }, { root: true }),
    ]);
  },
  async dispatchActionsOnPublicationsTab({ dispatch, rootState }) {
    const isChannelEqualTodas = rootState.ui.channel.toUpperCase() === 'TODAS';
    const isChannelEqualYoutube = rootState.ui.channel.toUpperCase() === 'YOUTUBE';

    const isDifferentTodasAndYoutube = (!isChannelEqualTodas && !isChannelEqualYoutube);

    await Promise.allSettled([
      dispatch({ type: 'charts/fetchTotalPublications' }, { root: true }),
      isDifferentTodasAndYoutube && dispatch({ type: 'charts/fetchPublicationsByMediaType' }, { root: true }),
      !isChannelEqualTodas && dispatch({ type: 'charts/fetchTopPublications' }, { root: true }),
      !isChannelEqualTodas && dispatch({ type: 'charts/fetchPublicationsOverTimeWithDistribution' }, { root: true }),
    ]);
  },
  async dispatchActionsOnInteractionsTab({ dispatch, rootState }) {
    const socialName = rootState.ui.channel.toUpperCase();
    const isChannelEqualTodas = socialName === 'TODAS';
    const isChannelInstagram = socialName === 'INSTAGRAM';

    const isDifferentTodasAndInstagram = (!isChannelEqualTodas && !isChannelInstagram);

    await Promise.allSettled([
      dispatch({ type: 'charts/fetchInteractionsOverTime' }, { root: true }),
      dispatch({ type: 'insights/fetchInteractionsOverTimeInsights' }, { root: true }),
      dispatch({ type: 'charts/fetchInteractionsAndEngagementRate' }, { root: true }),
      dispatch({ type: 'charts/fetchEngagementOverTime' }, { root: true }),
      dispatch({ type: 'charts/fetchAverageInteractionsByPublication' }, { root: true }),
      !isChannelEqualTodas && dispatch({ type: 'charts/fetchDistributionOfInteractions' }, { root: true }),
      dispatch(
        { type: isChannelEqualTodas ? 'charts/fetchInteractionsBySocialNetwork' : 'charts/fetchInteractionsByMediaType' },
        { root: true }
      ),
      isDifferentTodasAndInstagram && dispatch({ type: 'charts/fetchEngagementMatrix' }, { root: true }),
    ]);
  },
  async dispatchActionsOnSentimentsTab({ dispatch, rootState }) {
    const socialName = rootState.ui.channel.toUpperCase();
    const isChannelEqualTodas = socialName === 'TODAS';
    const isChannelInstagram = socialName === 'INSTAGRAM';

    const isDifferentTodasAndInstagram = (!isChannelEqualTodas && !isChannelInstagram);

    await Promise.allSettled([
      isDifferentTodasAndInstagram && dispatch({ type: 'charts/fetchSentimentsInTheComments' }, { root: true }),
      isDifferentTodasAndInstagram && dispatch({ type: 'charts/fetchTermsMentioned' }, { root: true }),
      isDifferentTodasAndInstagram && dispatch({ type: 'charts/fetchSentimentsInTheCommentsOverTime' }, { root: true }),
    ]);
  },
};
